import { ReactElement } from "react";
import styles from "./styles.module.css";
import { MetaCalendario } from "../../../model/PlanoDeTrabalho/PlanoAplicacao";

type Props = {
  metaObj: MetaCalendario;
  children?: React.JSX.Element;
};

const RowCalendario = ({ metaObj, children }: Props) => {
  return (
    <tr className={styles.row}>
      <td className={styles.center}>
        {metaObj.etapa}.{metaObj.fase}
      </td>
      <td className={styles.center}>{metaObj.ano}</td>
      {metaObj.meses.map((mes) => (
        <td className={styles.center}>{mes.toFixed(2)}</td>
      ))}
      <td className={styles.center}>
        R$ {metaObj.meses.reduce((acc, val) => acc + val).toFixed(2)}
      </td>

      {children && <td className={styles.btncoll}>{children}</td>}
    </tr>
  );
};
export default RowCalendario;
